import React, {useEffect, useState} from 'react';
import axios from '../Common/axios';
import {getFindReportIdInfo} from './api';
import {dateFormatter} from '../Common/util';
import Cookies from 'js-cookie';

const ReportHeader = ({reportId, reportInfo, setReportInfo}) => {

    useEffect(() => {
        findReportList(reportId);
    }, [reportId]);

    // 레포트 조회
    const findReportList = (reportId) => {
        if(reportId) {
            axios.get(getFindReportIdInfo(reportId))
                .then((response) => {
                    //console.log(response);
                    setReportInfo(response.data[0]);
                })
                .catch((error) => {
                    console.log("ReportHeader.js --- 23 error");
                    console.dir(error);
                });
        }
    }

    return (
        <>
                <table className='search'>
                    <colgroup>
                        <col style={{width:'10%'}} />
                        <col style={{width:'30%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'15%'}} />
                        <col style={{width:'10%'}} />
                        <col style={{width:'15%'}} />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th>보고서명</th>
                        <td>{reportInfo.report_nm}</td>
                        <th>보고자</th>
                        <td>{Cookies.get('auth_userName')}</td>
                        <th>분석기간</th>
                        <td>{dateFormatter(reportInfo.created_ymd)} {reportInfo.updated_ymd?' ~ ':''} {dateFormatter(reportInfo.updated_ymd)}</td>
                    </tr>
                    <tr><th>요약정보</th>
                        <td colSpan={5}>{reportInfo.report_desc}</td>
                    </tr>
                    </tbody>
                </table>
        </>
    );
}

export default ReportHeader;